export enum NRecomendadoEnum {
  NO_APROBADO = '5',
  NIVEL_CANDIDATO = '1',
  NIVEL_I = '2',
  NIVEL_II = '3',
  NIVEL_III = '4',
  NIVEL_EMERITO = '6',
}
